import { createContext, useState, useEffect, useContext } from "react";
import { getAPI } from "./api/api";

const FeaturesContext = createContext({});

export const FeaturesProvider = ({ children }) => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    try {
      const response = await getAPI("api/orders/features");
      if (response?.data?.features) {
        setFeatures(response.data.features);
      }
    } catch (error) {
      console.error("Failed to fetch features:", error);
    }
  };

  const isFeatureEnabled = (id) => {
    return features.some(f => f.id_feature === id && f.owned === 1);
  };

  const getEnabledFeatures = () => {
    return features.filter(f => f.owned === 1);
  };

  return (
    <FeaturesContext.Provider value={{ features, fetchFeatures, isFeatureEnabled, getEnabledFeatures }}>
      {children}
    </FeaturesContext.Provider>
  );
};

// maar even een custom hook hiervoor gemaakt
export const useFeatures = () => {
  const context = useContext(FeaturesContext);
  if (context) return context;
};

export default FeaturesContext;
